import React from 'react'
import PropTypes from 'prop-types'
import i18n from 'i18next'

export default function ProgressBar(props) {
  const {percentage} = props

  const fillStyle = {
    width: `${percentage || 0}%`,
  }
  return (
    <div className="progress-bar">
      <div data-testid="progress-text" className="progress-text">
        <span className="progress-percentage">{i18n.t('meineausbildung_progress_percentage', [percentage || 0])}</span>
        {i18n.t('meineausbildung_progress_text2')}
      </div>
      <div data-testid="progress-percentage" className="meter">
        <span className="fill" style={fillStyle} />
      </div>
    </div>
  )
}

ProgressBar.propTypes = {
  percentage: PropTypes.number,
}
